import type { ButtonVanillaVariant } from '@ag1/ui/components/ButtonVanilla/ButtonVanilla';

const BUTTON_VANILLA_VARIANTS: ButtonVanillaVariant[] = [
  'primary',
  'secondary',
  'tertiary',
  'link',
  'terminal',
  'goGreen',
  'fuchsia',
  'primaryOnDark',
  'tertiaryOnDark',
  'linkOnDark'
];

export const isButtonVanillaVariant = (variant: string): variant is ButtonVanillaVariant =>
  BUTTON_VANILLA_VARIANTS.includes(variant as ButtonVanillaVariant);

export const normalizeTimer = (rawTimer: number) => {
  if (!rawTimer || rawTimer <= 0) return 0;
  if (rawTimer < 100) return rawTimer * 1000;
  return rawTimer;
};
